import { render, staticRenderFns } from "./GChatBuyerListItemContainer.vue?vue&type=template&id=7048ac87&"
import script from "./GChatBuyerListItemContainer.vue?vue&type=script&lang=ts&"
export * from "./GChatBuyerListItemContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports